// Shared by AddAccountModal (internal admin stands up a demo account) and SignupPage
// (self-service signup) — both need to notify Zapier once a new top-level team exists.

// Not secret-bearing (a Zapier "catch hook" URL), safe to call from the browser.
const ZAPIER_NEW_ACCOUNT_WEBHOOK_URL = 'https://hooks.zapier.com/hooks/catch/7723146/4mk267b/'

type NewAccountParams =
  | {
      type: 'internalAdmin'
      topLevelTeamId: string
      topLevelTeamName: string
      logoURL?: string | null
    }
  | {
      type: 'selfService'
      topLevelTeamId: string
      topLevelTeamName: string
      logoURL?: string | null
      profile: { userId: string; name: string; email: string }
    }

// Fire-and-forget, best-effort — must not block or fail the account-creation flow it's called
// from. Only call this once the team (and, if present, its branding asset) already exists.
//
// GET + query string, no custom headers — matches startTrial's proven pattern for the same
// reason: a POST with a JSON/text Content-Type header forces a CORS preflight first, and
// Zapier's catch-hook response doesn't allow Content-Type in Access-Control-Allow-Headers, so
// the browser blocks the real request from ever being sent. A plain GET with no custom headers
// is always CORS-simple — no preflight needed.
export function notifyNewAccountCreated(params: NewAccountParams) {
  const webhookParams = new URLSearchParams({
    event: 'New Account Created',
    type: params.type,
    topLevelTeamId: params.topLevelTeamId,
    topLevelTeamName: params.topLevelTeamName,
    logoURL: params.logoURL ?? '',
  })
  if (params.type === 'selfService') {
    webhookParams.set('profileUserId', params.profile.userId)
    webhookParams.set('profileName', params.profile.name)
    webhookParams.set('profileEmail', params.profile.email)
  }
  fetch(`${ZAPIER_NEW_ACCOUNT_WEBHOOK_URL}?${webhookParams.toString()}`).catch(() => {})
}
